// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchInput_searchContainer__kQDsT"};